import { values } from 'lodash';

import { EnumSetItem } from '../typings/filter';

export function castStringToUnion<T extends string>(value: string, valuesData: Array<string>): T {
    if (valuesData.indexOf(value) !== -1) {
        return <T>value;
    }

    throw new Error(`Couldn't convert ${value} to union [${valuesData}]`);
}

export function castStringToEnum<T>(value: string, valuesData: T): T[keyof T] {
    if (valuesData[value]) {
        return valuesData[value];
    }

    throw new Error(`Couldn't convert ${value} to enum [${valuesData}]`);
}

export function getEnumSetFrom<T>(enumObject: T, titles: { [key in keyof T]?: string }): Array<EnumSetItem> {
    return Object.keys(enumObject)
        .filter(key => titles[key])
        .map(key => {
            return {
                key,
                title: titles[key]
            };
        });
}

export function isEnumValue(enumObject: {}, value: string): boolean {
    return values(enumObject).indexOf(value) !== -1;
}
